/* eslint-disable restrict-imports/restrict-imports */
import CopyToClipboard from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from 'design-system/product/theme';
import CatalogAlert from 'react-scale/catalog/components/CatalogAlert';

type CopyCellProps = {
  name: string;
  value: string;
  copy?: string;
  tooltip?: string;
};

function CopyCell({ value, name, copy, tooltip }: CopyCellProps) {
  const classes = useStyles();
  const cell = (
    <div className={classes.copyContainer}>
      {value}
      <FontAwesomeIcon className={classes.copyIcon} icon="copy" />
    </div>
  );

  return (
    <CopyToClipboard
      text={copy ?? value}
      onCopy={value =>
        CatalogAlert.success(`Copied ${name} "${value}" to clipboard!`, {
          autoClose: 2000,
        })
      }
    >
      {tooltip ? <Tooltip title={tooltip}>{cell}</Tooltip> : cell}
    </CopyToClipboard>
  );
}

const useStyles = makeStyles(theme => ({
  copyIcon: {
    display: 'none',
  },
  copyContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    cursor: 'pointer',
    '&:hover': {
      '& $copyIcon': {
        display: 'block',
      },
    },
  },
}));

export default CopyCell;
